import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { BrandCategoriesStateContext } from "@insite/client-framework/Store/Data/Brands/BrandsSelectors";
import { BrandStateContext } from "@insite/client-framework/Store/Data/Brands/BrandsSelectors";
import translate from "@insite/client-framework/Translate";
import { BrandCategoryModel } from "@insite/client-framework/Types/ApiModels";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Button from "@insite/mobius/Button";
import Clickable from "@insite/mobius/Clickable";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Img, { ImgProps } from "@insite/mobius/Img";
import LazyImage, { LazyImageProps } from "@insite/mobius/LazyImage";
import Link, { LinkPresentationProps, LinkProps } from "@insite/mobius/Link";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import { breakpointMediaQueries, getProp } from "@insite/mobius/utilities";
import { useHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { COLORS, TYPOGRAPHY } from "@tCentro/theme/design";
import React, { FC, useContext } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const enum fields {
    title = "title",
    showImages = "showImages",
    subCategoriesToShow = "subCategoriesToShow",
}
interface OwnProps extends WidgetProps {
    fields: {
        [fields.title]: string;
        [fields.showImages]: boolean;
        [fields.subCategoriesToShow]: number;
    };
}

const mapStateToProps = (state: ApplicationState) => ({});

const mapDispatchToProps = {};

type Props = ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps> & OwnProps;

export interface NISBrandDetailsCategoriesStyles {
    title?: TypographyProps;
    container?: InjectableCss;
    categoryContainer?: GridContainerProps;
    categoryItem?: GridItemProps;
    categoryImageItem?: GridItemProps;
    categoryImage?: ImgProps;
    categoryNameLinkItem?: GridItemProps;
    categoryNameLink?: LinkProps;
    categoryWrapper?: InjectableCss;
    imgLink?: LinkPresentationProps;
    img?: ImgProps;
    categoryLink?: LinkPresentationProps;
    buttonContainer?: InjectableCss;
    button?: InjectableCss;
}

export const nisCategoriesStyles: NISBrandDetailsCategoriesStyles = {
    button: {
        css: css`
            border-radius: 4px;
            background-color: #2b5197;
            color: white;
            padding: 12px 16px;
            text-transform: uppercase;
            background-color: #2b5197;
            > span{
              font-size: 18px;
            line-height: 18px;
            font-weight: 700;
            font-family: 'Roboto Condensed';
             }
           
        `,
    },
    buttonContainer: {
        css: css`
            display: flex;
            justify-content: center;

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin-top: 24px;
                    `,
                    css`
                        margin-top: 24px;
                    `,
                    css`
                        margin-top: 32px;
                    `,
                    css`
                        margin-top: 40px;
                    `,
                    css`
                        margin-top: 40px;
                    `,
                ])}
        `,
    },
    categoryLink: {
        css: css`
            margin-top: 0px;
            font-family: Roboto Condensed;
            font-weight: 700;
            font-size: 16px;
            line-height: 24px;
            color: #333333;
            text-transform: uppercase;
            text-decoration: none;
            justify-content: center;
  @media(min-width:1024px) and (max-width:1366px){
           padding:0px 10px;
            }
            & > span {
                color: #333333 !important;
            }
            cursor: pointer;
            &:focus,
            &:hover {
                text-decoration: none;
                outline: none;
            }
        `,
    },
    img: {
        height: 160,
        css: css`
            cursor: pointer;
            width: 160px;
            @media(min-width:768px) and (max-width:819px){
             height: 80px !important;
             width: 80px !important;
            }
           
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        height: 80px;
                        object-fit: fill;
                        width: 80px;
                    `,
                    css`
                        height: 80px;
                        width: 80px;
                    `,
                    css`
                        height: 160px;
                        width: 160px;
                    `,
                    css`
                        height: 160px;
                    `,
                    null,
                ])}
        `,
    },
    imgLink: {
        css: css`
            text-decoration: none;
            justify-content: center;
            span {
                max-height: 160px;
                @media(max-width:768px){
                  max-height: 80px;
                }
            }
            &:focus,
            &:hover {
                text-decoration: none;
                outline: none;
            }
        `,
    },
    container: {
        css: css`
            background-color: ${COLORS.background.grayShade};
            margin-bottom: 92px;
            padding: 64px;
            & > div {
                & > div {
                    justify-content: center;
                }
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin-top: 56px;
                        padding: 32px 16px;
                    `,
                    css`
                        margin-top: 56px;
                        padding: 32px 16px;
                    `,
                    css`
                        margin-top: 56px;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    title: {
        variant: "h2",
        transform: "inherit",
        css: css`
        display: flex;
            color: ${getProp("theme.typography.h2.color")};
            margin-bottom: 40px;
            text-align: center;
            font-size: 32px !important;
            line-height: 40px;
            font-weight: 600;
            color: #2b5197;
            justify-content: center;
            font-family: 'Roboto Condensed';
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        css`
                            font-weight: 600;
                             justify-content: start;
                             text-align: start;
                        `,
                        css`
                            margin-bottom: 24px;
                             justify-content: start;
                             text-align: start;
                        `,
                    ],
                    "max",
                );
            }}
        `,
    },
    categoryContainer: {
        gap: 0,
        css: css`
            display: grid;
            gap: 24px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        grid-template-columns: repeat(1, 1fr);
                    `,
                    css`
                        grid-template-columns: repeat(1, 1fr);
                    `,
                    css`
                        grid-template-columns: repeat(2, 1fr);
                        gap: 16px;
                    `,
                    css`
                        grid-template-columns: repeat(4, 1fr);
                    `,
                    css`
                        grid-template-columns: repeat(4, 1fr);
                    `,
                ])}
            >div[class^="GridItemStyle"] {
                max-width: none;
            }
        `,
    },

    categoryImageItem: {
        width: 12,
        align: "middle",
        css: css`
            width: 100%;
            justify-content: center;
            border: 2px solid blue;
            > span {
                border: 2px solid green;
            }
            img {
                max-height: 160px;
            }
        `,
    },

    categoryImage: {
        css: css`
            width: 100%;
            height: 100%;
            aspect-ratio: 1/1;
            object-fit: fill;
        `,
    },
    categoryWrapper: {
        css: css`
            width: 100%;
            background: white;
            display: flex;
            flex-direction: column;
            justify-content: center !important;
            padding: 16px 0px;
            border:1px solid #E0DFE0;
            border-radius:8px;

            gap: 16px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-direction: row;
                        gap: 8px;
                         padding: 8px 0px 8px 16px;
                         justify-content: start !important;
                    `,
                    css`
                        flex-direction: row;
                        gap: 8px;
                         padding: 8px 0px 8px 16px;
                         justify-content: start !important;
                    `,
                    null,
                    null,
                    null,
                ])}
        `,
    },
   
    categoryNameLink: {
        css: css`
            width: 100%;
            height: 100%;
            span {
                color: ${getProp("theme.typography.p.color")} !important;
                font-weight: ${TYPOGRAPHY.weight.mediumbold};
                font-size: ${TYPOGRAPHY.size.large};
                line-height: 24px;
            }
        `,
    },

  
 
  
};

const styles = nisCategoriesStyles;

const NISBrandDetailsCategories: FC<Props> = ({ fields }) => {
    const { value: brand } = useContext(BrandStateContext);
    if (!brand) {
        return null;
    }
    const { isLoading, value: brandCategories } = useContext(BrandCategoriesStateContext);
    if (isLoading || !brandCategories) {
        return null;
    }

    const minHeightValue = `${fields.subCategoriesToShow * 130}px`;

    const categoryItem: GridItemProps = {
        width: [12, 6, 4, 3, 2],
        css: css`
            div[class^="GridWrapper"] {
                height: 100%;
            }
        `,
    };
    const { title, showImages, subCategoriesToShow } = fields;
    const history = useHistory();
    const handler = (e: React.MouseEvent) => {
        history.push(brand?.productListPagePath);
        e.preventDefault();
    };

    return (
        <StyledWrapper {...styles.container} data-test-selector="brandCategories">
            {brand.properties.hasProducts !== "false" && brand.properties.hasProducts !== undefined && (
                <>
                    <Typography {...styles.title} data-test-selector="brandCategoriesTitle">
                          {translate("Shop by {0} Product Categories").replace("{0}", brand.name)}
                    </Typography>

                    <StyledWrapper {...styles.categoryContainer}>
                        {brandCategories!.map(category => (
                            <>
                                <StyledWrapper key={`categories_${category.categoryId}`} {...styles.categoryWrapper}>
                                    <Link href={category.productListPagePath} {...styles.imgLink}>
                                        <Img
                                            src={category.featuredImagePath}
                                            altText={category.categoryName}
                                            title={category.categoryName}
                                            {...styles.img}
                                        />
                                    </Link>
                                    <Link href={category.productListPagePath} {...styles.categoryLink}>
                                        {category.categoryName}
                                    </Link>
                                </StyledWrapper>
                            </>
                        ))}
                      
                    </StyledWrapper>
                    <StyledWrapper {...styles.buttonContainer}>
                        {brandCategories.length > subCategoriesToShow && (
                            <Button {...styles.button} onClick={handler}>
                                {translate("View All {0} Products").replace("{0}", brand.name)}
                            </Button>
                        )}
                    </StyledWrapper>
                </>
            )}
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(NISBrandDetailsCategories),
    definition: {
        group: "Brand Details",
        displayName: "NIS Categories",
        allowedContexts: ["BrandDetailsPage"],
        fieldDefinitions: [
            {
                name: fields.title,
                displayName: "Title",
                editorTemplate: "TextField",
                defaultValue: "Shop By Category",
                fieldType: "Translatable",
            },
            {
                name: fields.showImages,
                displayName: "Show Images",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
            },
            {
                name: fields.subCategoriesToShow,
                displayName: "Sub Categories To Show",
                editorTemplate: "IntegerField",
                tooltip: "You can add a maximum of 4 subcategories",
                placeholder: "Maximum limit is 4",
                max: 4,
                tooltipPosition: "left",
                defaultValue: 4,
                fieldType: "General",
            },
        ],
    },
};

export default widgetModule;
